import React from 'react';
import { Stack, Flex, Button, Text, VStack, useBreakpointValue, Image, Box } from '@chakra-ui/react'
//import { NavLink } from 'react-router-dom'
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const shimmerEffect = keyframes`
  0% { box-shadow: 0 0 10px 5px rgba(255, 215, 0, 0); }
  50% { box-shadow: 0 0 20px 5px rgba(255, 215, 0, 0.5); }
  100% { box-shadow: 0 0 10px 5px rgba(255, 215, 0, 0); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const spinEntrance = keyframes`
  0% { transform: rotate(180deg) scale(0.3); opacity: 0; }
  70% { transform: rotate(-20deg) scale(1.1); opacity: 0.8; }
  100% { transform: rotate(0deg) scale(1); opacity: 1; }
`;

const Header = () => {
  return (
    <Flex
      w={'full'}
      h={useBreakpointValue({ base: '100vh', md: '100vh', lg: '100vh' })}
      backgroundImage="url('/assets/images/header.webp')"
      backgroundSize={'cover'}
      backgroundPosition={'center center'}>
      <VStack
        w={'full'}
        justify={'space-between'}
        alignContent={'center'}
        px={useBreakpointValue({ base: 4, md: 8 })}
        bgGradient={'linear(to-r, blackAlpha.900, transparent)'}>
        <Box 
          w={useBreakpointValue({ base: '120px', md: '150px', lg: '180px' })}
          mt={useBreakpointValue({ base: 6, md: 8 })}
          position="relative"
          borderRadius="full"
          padding="2px"
          _after={{
            content: '""',
            position: 'absolute',
            top: '-5px',
            left: '-5px',
            right: '-5px',
            bottom: '-5px',
            borderRadius: 'full',
            animation: `${shimmerEffect} 3s infinite`
          }}
          animation={`${fadeIn} 1s ease-in-out 0.1s both, ${spinEntrance} 1s ease-in-out both`}>
          <Image 
            src="/assets/images/logo.svg" 
            alt="Cicabank Logo"
            filter="drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.5))"
          />
        </Box>
        <Stack
          maxW={useBreakpointValue({ base: '90%', md: '5xl' })}
          align={'center'}
          mt={useBreakpointValue({ base: 4, md: 10 })}
          animation={`${fadeIn} 1s ease-in-out 0.2s both`}>
            <Text
              color={'white'}
              fontWeight={700}
              lineHeight={1.2}
              fontSize={useBreakpointValue({ base: '4xl', md: '7xl' })}
              textShadow="20px 10px 15px #000000"
              style={{ WebkitTextStroke: '1px #FFD700' }}>
              Cicabank
            </Text>
        </Stack>
        <Stack
          maxW={useBreakpointValue({ base: '90%', md: '5xl' })}
          align={'center'}
          mt={'auto'}
          mb={'auto'}
          animation={`${fadeIn} 1s ease-in-out 0.4s both`}>
          <Text
            color={'white'}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: '2xl', md: '4xl' })}
            textShadow="2px 2px 2px #000000"
            textAlign={useBreakpointValue({ base: 'justify', md: 'center' })}>
            Et si tu pouvais effectuer tes opérations bancaires partout, à tout moment, sans jamais aller en agence !
          </Text>
        </Stack>
        <Stack
          maxW={useBreakpointValue({ base: '90%', md: '5xl' })}
          align={'center'}
          mt={'auto'}
          mb={'auto'}
          animation={`${fadeIn} 1s ease-in-out 0.6s both`}>
          <Text
            color={'white'}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: '2xl', md: '4xl' })}
            textShadow="2px 2px 2px #000000"
            textAlign={useBreakpointValue({ base: 'justify', md: 'center' })}>
            Es-tu prêt à rejoindre la révolution bancaire en Afrique de l'Ouest ?
          </Text>
        </Stack>
        <Stack 
          direction={useBreakpointValue({ base: 'column', md: 'row' })}
          mt={'auto'}
          animation={`${fadeIn} 1s ease-in-out 0.6s both`}>
          <Button
            as={'a'}
            bg={'#FFD700'}
            rounded={'full'}
            color={'black'}
            _hover={{ 
              bg: '#ffd900cc',
              transform: 'translateY(-2px)',
              boxShadow: 'lg',
            }}
            animation={`${pulse} 2s infinite ease-in-out`}
            href="#form">
            Rejoins-nous maintenant
          </Button>
        </Stack>      
        <Stack
          maxW={useBreakpointValue({ base: '90%', md: '5xl' })}
          align={'center'}
          mt={'auto'}
          mb={'auto'}
          animation={`${fadeIn} 1s ease-in-out 0.9s both`}>
          <Text
            color={'white'}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: 'xl', md: '2xl' })}
            textShadow="2px 2px 2px #000000">
            Bientôt disponible !
          </Text>
        </Stack>
      </VStack>
    </Flex>
  );
};

export default Header;